import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import ConfirmAndCancel from '../Buttons/ConfirmAndCancel';
import Moment from 'react-moment';
// import moment from "moment";
import Auth from "../../Auth/Auth";

function RequestDayOffPopup({ show, onClose, onConfirm, booking, inst, campus, level }) {
  let role = Auth.verifyUserRole();
  // console.log(`role: ${role}`);
  const { booking_date, end_booking_date, start_time } = booking;

  // Calculates number of hours until class starting time

  const bookingDateTime = `${booking_date} ${start_time}`;
  const diffInMilliSeconds =
    Date.parse(bookingDateTime) - Date.parse(new Date());
  const hoursUntilClass = diffInMilliSeconds / (1000 * 60 * 60);

  return (
    <Modal
      show={show}
      onClose={onClose}
      header='Request Day Off'
      className='delete-modal'
    >
      <p className='center-text'>
        <strong hidden={hoursUntilClass >= 0}>
          It's not possible to cancel bookings that passed their starting time.
        </strong>
        <strong>{inst.institution_name}</strong>
        <br/>
        <span>
          <Moment format='DD MMM YYYY'>{end_booking_date}</Moment>
        </span>
        <br/>
        <span>
          {level} @ ${campus.address_line1 + (campus.address_line2 ? ', ' + campus.address_line2 : '')}
        </span>
      </p>
      <br/>

      {hoursUntilClass < 0 || (
        <>
          <ConfirmAndCancel
            onCancel={onClose}
            cancelText='Go Back'
            onConfirm={() => {
              onConfirm();
              onClose();
            }}
            confirmText='Confirm'
          />
        </>
      )}
    </Modal>
  );
}

export default RequestDayOffPopup;